<template>
<div class="bg-light">
  
  
  <Banner title="Files"
	     pricing="true"
	     level="2"
	     bg-color="#fff"
	     class="sticky-top" />



  <Layout01>
    <div slot="icon">
      <b-img :src="require('../assets/trinapp_files.png')" class="mr-3" style="height: 114px;" />
    </div>
    <div slot="header">
      TrinApp<sup>&trade;</sup> Files
    </div>
    <div slot="subtitle">
      File storage built on top of TrinPods with Trinity conceptual AI
    </div>
    <div slot="description">
      We think you should have 100% ownership and control over your files; who has access to your files, where they are stored, and what apps you use to access them.
    </div>
  </Layout01>


  
  <b-container style="background-color: #08034c; font-family: Arial, Helvetica, sans-serif; font-size: 1.2rem;" fluid>
    <b-row class="text-light text-center px-0 py-1">
      <b-col cols="12" md="4">
	<b-button
	  class="border-0 bg-transparent"
	  @click="goto('obscure')"
	  >
	  <b-img :src="require('../assets/ocr_icon.png')" class="mr-1" style="height: 36px;" />
	  <span class="link-ref-text">Find Obscure Documents</span>
	</b-button>
      </b-col>
      <b-col cols="12" md="4">
	<b-button
	  class="border-0 bg-transparent"
	  @click="goto('human')"
	  >
	  <b-img :src="require('../assets/trinity.png')" class="mr-1" style="height: 36px;" />
	  <span class="link-ref-text">Human Approach</span>
	</b-button>
      </b-col>
      <b-col cols="12" md="4">
	<b-button
	  class="border-0 bg-transparent"
	  @click="goto('silo')"
	  >
	  <b-img :src="require('../assets/solid_logo_tr.png')" class="mr-1" style="height: 36px;" />
	  <span class="link-ref-text">Connect Silos</span>
	</b-button>
      </b-col>
    </b-row>
    <b-row style="background-color: #585aff; height: 16px;">
      <b-col>
      </b-col>
    </b-row>
  </b-container>



  <div ref="obscure" />


  
  <Layout02>
    <div slot="icon">
      <b-img :src="require('../assets/trinity.png')" class="pt-5" style="width: 100px;" />
    </div>
    <div slot="header">
	Find Obscure Documents Fast
    </div>
    <div slot="description">
      <p class="mb-0">Conceptual AI Magic!</p>
      <p class="mb-0">Trinity will be working for you.</p>
      <p class="mb-5">Her conceptual AI skills enable you to find your files without you having to remember the exact keywords.</p>
      <p class="mb-0">Then you can browse linked information using Trinity's One-World model.</p>
    </div>
    <div slot="button">
      <b-button size="lg" class="btn-neon-blue my-5" href="https://trinpod.us/pricing?industry=productivity">Get Started</b-button>
    </div>
  </Layout02>



  <VideoSection 
		title="vimeo-files-demo" 
		src="https://player.vimeo.com/video/537450167"
	/>



  <Layout03 checkColor="#27e1a2" />


  
  <div ref="human" />



  <Layout04 checkColor="#27e1a2" />



  <ImageWithButtonSection 
    sectionColorClass="bg-light"
    image="trinapp-files.png"
    :figCaption="'TrinApp\u2122 Files'" 
    industry="productivity" 
  />



  <div ref="silo" />
  <Layout05 checkColor="#27e1a2" />



  <Layout06 checkColor="#27e1a2" />


  
  <Layout07>
    <div slot="list">
      <ol>
	<li>Sign up for TrinPod<sup>&trade;</sup></li>
	<li>Get TrinApp<sup>&trade;</sup> Files</li>
      </ol>
    </div>
    <div slot="description">
      <p class="mb-0">You are done.</p> 
      <p class="mb-0"> You can upload files and Trinity will place your information into the one-world model where she can do her magic to help you.</p>
      <p class="mb-0">You can get your work done faster by seeing new relationships and finding your files with ease.</p>
      <p class="mb-0">You can Securely collaborate with your friends and colleagues</p>
    </div>
  </Layout07>

  

  <Layout08 bg-color="#27e1a2" />


  
  <GmxFooter />


  
</div>
</template>

<script>
import Banner from '@/components/gmx-banner.vue';
import GmxFooter from '@/components/footer.vue';
import Layout01 from '@/components/layout-01.vue';
import Layout02 from '@/components/layout-02.vue';
import Layout03 from '@/components/layout-03.vue';
import Layout04 from '@/components/layout-04.vue';
import Layout05 from '@/components/layout-05.vue';
import Layout06 from '@/components/layout-06.vue';
import Layout07 from '@/components/layout-07.vue';
import Layout08 from '@/components/layout-08.vue';
import VideoSection from '@/components/video-section.vue';
import ImageWithButtonSection from '@/components/image-with-button-section.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import * as log from 'loglevel'
export default {
    name: "TrinAppFiles",
    components: {
	Banner,
	GmxFooter,
	Layout01,
	Layout02,
	Layout03,
	Layout04,
	Layout05,
	Layout06,
	Layout07,
	Layout08,
  VideoSection,
  ImageWithButtonSection,
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

